import { render } from "./DashboardGoalBilled.vue?vue&type=template&id=6cf51adf&scoped=true&ts=true"
import script from "./DashboardGoalBilled.vue?vue&type=script&lang=ts"
export * from "./DashboardGoalBilled.vue?vue&type=script&lang=ts"

import "./DashboardGoalBilled.vue?vue&type=style&index=0&id=6cf51adf&lang=scss&scoped=true"

import exportComponent from "/home/node/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cf51adf"]])

export default __exports__